module.exports = __webpack_public_path__ + "static/media/selectGGcardType.3d64222e.svg";